import React from 'react';
import { Alert, Tag, Typography } from 'antd';
import type { DailyTradingAdviceResponse } from '@/api/weatherTradingAdvice';

const { Text } = Typography;

interface Props {
  data: DailyTradingAdviceResponse;
  children: React.ReactNode;
}

const WeatherEvidenceTab: React.FC<Props> = ({ data, children }) => (
  <div>
    <section style={{ border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', padding: 14, marginBottom: 12 }}>
      <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>证据摘要</div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
        {data.evidence.cards.map((card) => (
          <Tag key={card.id}>{card.title}</Tag>
        ))}
      </div>
      {data.evidence.conflicts.length > 0 && (
        <Alert
          type="warning"
          showIcon
          message="冲突信号"
          description={data.evidence.conflicts.map((conflict) => (
            <div key={conflict.message}>
              <Text>{conflict.message}</Text>
              {conflict.impact && <Text type="secondary"> · {conflict.impact}</Text>}
            </div>
          ))}
        />
      )}
    </section>
    {children}
  </div>
);

export default WeatherEvidenceTab;
